import {UserAPIInterface} from "@/entity/User";

export interface ReservationCardConfig {
  card: CardConfig,
  title: SeparatorConfig
}

export enum CardStatus {
  Normal = '',
  Disabled = 'ReservationCardDisabled',
  Loading = 'ReservationCardLoading',
}

export interface CardConfig {
  path: string;
  class: CardStatus;
  day: Day;
  name: string;
  hours: Hours;
  owner: UserAPIInterface | string;
}

export interface SeparatorConfig {
  text: string;
  isMonthDisplayed: boolean;
}

export interface Day {
  withDay: boolean
  number: string;
  text: string;
  isCurrentDay: boolean;
}

export interface Hours {
  start: string;
  end: string;
}
